import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=35bafe82&scoped=true&"
import script from "./Draggable.vue?vue&type=script&lang=js&"
export * from "./Draggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bafe82",
  null
  
)

export default component.exports